import { useEffect, useRef } from 'react';

import type { DependencyList, EffectCallback} from 'react';

function useEffectExceptForFirstRendering(func: EffectCallback, deps: DependencyList) {
  const isFirstRendering = useRef(true);

  useEffect(() => {
    if (isFirstRendering.current) {
      isFirstRendering.current = false;
    } else {
      func();
    }
     
  }, deps);
}

export default useEffectExceptForFirstRendering;
